import { SeatRow } from './work-queue.utils';

export interface AccountWorkClaim {
  seat: SeatRow;
  state: 'working' | 'idle' | 'parked' | 'obligations' | 'unknown';
}

/** Join by reported account identity, never by seat-name suffix or quota share. */
export function groupAccountWorkClaims(
  rows: SeatRow[],
  sourceUnavailable = false
): Map<string, AccountWorkClaim[]> {
  const groups = new Map<string, AccountWorkClaim[]>();
  for (const seat of rows) {
    if (seat.retired) continue;
    const key = seat.accountUpn?.trim().toLowerCase() ?? '';
    const state: AccountWorkClaim['state'] =
      sourceUnavailable ||
      !seat.modelAlive ||
      seat.reportedAgeMinutes == null ||
      seat.hasDisagreement ||
      seat.ticketStale
        ? 'unknown'
        : seat.parkedReason
          ? 'parked'
          : seat.active
            ? 'working'
            : seat.owedItems.length || seat.openInboundCount
              ? 'obligations'
              : seat.currentTicketId ||
                  seat.currentTicketTitle ||
                  seat.currentActivity
                ? 'unknown'
                : 'idle';
    const group = groups.get(key) ?? [];
    group.push({ seat, state });
    groups.set(key, group);
  }
  return groups;
}
